export * from './DataChartTrendXyUpIcon';
export * from './DataChartTrendXyUpIcon16Light';
export * from './DataChartTrendXyUpIcon16Regular';
export * from './DataChartTrendXyUpIcon16Solid';
export * from './DataChartTrendXyUpIcon20Light';
export * from './DataChartTrendXyUpIcon20Regular';
export * from './DataChartTrendXyUpIcon20Solid';
export * from './DataChartTrendXyUpIcon24Regular';
export * from './DataChartTrendXyUpIcon24Solid';
export * from './DataChartTrendXyUpIcon32Regular';
export * from './DataChartTrendXyUpIcon64Regular';
